/**
 * This object maps domains to specific country codes.
 */
export const domainToCountryMap: { [key: string]: string } = {
  net: "NL",
  dk: "DK",
  se: "SE",
  is: "IS",
  fi: "FI",
  no: "NO",
  "co.uk": "GB",
  be: "BE",
};
